module.exports = __webpack_public_path__ + "2efca881e24b43ea3affa39ba92d033e.MP3";